// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2LLV7","section-heading":"_1F-F8","grid-container":"_2LEKc","verticla-card":"_1rE_k","horizontal-cards":"_3Tnf3"};